import { IntegrationsSearchGrid } from './integrations-search-grid';
import { usePipesData } from './integrations-search-use-pipes-data';

export const BitbucketPipelinesIntegrations = () => {
	const { items, categories, loading, error } = usePipesData();

	if (loading) return <div>Loading integrations…</div>;
	if (error) return <div>Failed to load integrations.</div>;

	return <IntegrationsSearchGrid items={items} categories={categories} />;
};
